export const PAYMENT_OPTION_INSURANCE = 'insurance';
export const PAYMENT_OPTION_SELF_PAY = 'self-pay';
export const PAYMENT_OPTION_DECIDE_LATER = 'decide_later';
